// TODO: get back to this one
type ErrorOptions = { [key: string]: any };

interface AppErrorOptions extends ErrorOptions {
  code?: number;
  info?: Record<string, unknown>;
  cause?: unknown;
}

export class AppError extends Error {
  code?: number;
  info: Record<string, unknown>;
  genericMessage: string;
  public originalMessage: string;
  cause?: unknown;

  constructor(message: string, { code, info, cause }: AppErrorOptions = {}) {
    // super(message, options);
    super(message);

    this.code = code;
    this.info = info ?? {};
    this.cause = cause;

    // TODO: we should have message but at the same time, a public one
    //       to be ingested by the server when in production

    this.name = this.constructor.name;
    this.genericMessage = message;
    this.originalMessage = message;
  }

  public toString() {
    return JSON.stringify({
      code: this.code,
      info: this.info,
      genericMessage: this.genericMessage,
      cause: this.cause,
    });
  }
}

export type HTTPErrorOptions = Omit<AppErrorOptions, 'code'>;

export class InternalServerError extends AppError {
  constructor(message: string, options?: HTTPErrorOptions) {
    super(message, { ...options, code: 500 });
    this.genericMessage = 'Internal server error';
  }
}

export class BadRequestError extends AppError {
  constructor(message: string, options?: HTTPErrorOptions) {
    super(message, { ...options, code: 400 });
    this.genericMessage = 'Bad request';
  }
}

export class UnauthorizedError extends AppError {
  constructor(message: string, options?: HTTPErrorOptions) {
    super(message, { ...options, code: 401 });
    this.genericMessage = 'Unauthorized';
  }
}

export class ForbiddenError extends AppError {
  constructor(message: string, options?: HTTPErrorOptions) {
    super(message, { ...options, code: 403 });
    this.genericMessage = 'Forbidden';
  }
}

export class NotFoundError extends AppError {
  constructor(message: string, options?: HTTPErrorOptions) {
    super(message, { ...options, code: 404 });
    this.genericMessage = 'Not found';
  }
}

export class ConflictError extends AppError {
  constructor(message: string, options?: HTTPErrorOptions) {
    super(message, { ...options, code: 409 });
    this.genericMessage = 'Conflict';
  }
}

export class ContentTooLargeError extends AppError {
  constructor(message: string, options?: HTTPErrorOptions) {
    super(message, { ...options, code: 413 });
    this.genericMessage = 'Content too large';
  }
}

export function mapErrCoded(code?: number) {
  switch (code) {
    case 400:
      return BadRequestError;
    case 401:
      return UnauthorizedError;
    case 404:
      return NotFoundError;
    case 409:
      return ConflictError;
    case 413:
      return ContentTooLargeError;
    default:
      return InternalServerError;
  }
}

// this error should be the toString incoming from AppError
// otherwise it won't work as expected
export function AppErrorFromString(err: string) {
  if (typeof err !== 'string' || err.length === 0) {
    return undefined;
  }

  const parsed = JSON.parse(err) as {
    code?: number;
    info?: Record<string, unknown>;
    genericMessage?: string;
    message?: string;
    cause?: unknown;
  };

  const msg = parsed.genericMessage ?? parsed.message ?? '';
  const errObj = {
    code: parsed.code,
    info: parsed.info,
    cause: parsed.cause,
  };

  const ErrClass = mapErrCoded(parsed.code);
  return new ErrClass(msg, errObj);
}
